import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function Loader() {
    return (
        <Box sx={{ display: 'block', textAlign: "center", mt: 1 }}>
            <CircularProgress />
        </Box>
    );
}